import { useMemo } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Site } from '@hotjar/site';
import type { User } from '@hotjar/user';
import { experimentViewed } from '../experiment-viewed';
import { formSubmit } from '../form-submit';
import { trackClick } from '../track-click';
import { viewElement } from '../view-element';
import { alias } from '../alias';

export interface TrackFunctions {
  alias: (userId: number) => Promise<void>;
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  click: (eventName: string, uiPosition: string, groupData: any, additionalData?: any) => void;
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  viewElement: (
    eventName: string,
    uiPosition: string,
    groupData: any,
    additionalData?: any,
  ) => void;
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  formSubmit: (
    formName: string,
    submitSuccess: boolean,
    groupData: any,
    additionalData?: any,
  ) => Promise<any>;
  experimentAssigned: (experimentId: string, experimentTargetId: string, variationId: any) => void;
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  experimentViewed: (
    experimentId: string,
    experimentTargetId: string,
    variationId: any,
    userId?: any,
  ) => void;
}

export const useTrack = (currentSite?: Site, currentUser?: User): TrackFunctions => {
  return useMemo(() => {
    return {
      alias,

      // FIXME: Please fix this. You may refer to CFE-266 for more details.
      // eslint-disable-next-line func-params-args/func-params
      click: (eventName, uiPosition, groupData, additionalData) =>
        trackClick({ name: eventName, uiPosition, groupData, data: additionalData }),

      // FIXME: Please fix this. You may refer to CFE-266 for more details.
      // eslint-disable-next-line func-params-args/func-params
      viewElement: (eventName, uiPosition, groupData, additionalData) =>
        viewElement({ name: eventName, uiPosition, groupData, data: additionalData }),

      // FIXME: Please fix this. You may refer to CFE-266 for more details.
      // eslint-disable-next-line func-params-args/func-params
      formSubmit: (name, submitSuccess, groupData, data) =>
        formSubmit({ name, submitSuccess, groupData, data }),

      // FIXME: Please fix this. You may refer to CFE-266 for more details.
      // eslint-disable-next-line func-params-args/func-params
      experimentViewed: (experimentId, experimentTargetId, variationId, userId) => {
        experimentViewed({
          experimentId,
          experimentTargetId,
          variationId,
          userId,
          site: currentSite,
        });
      },

      experimentAssigned: (experimentId, experimentTargetId, variationId) => {
        experimentViewed({
          experimentId,
          experimentTargetId,
          variationId,
          userId: String(currentUser?.id),
          site: currentSite,
        });
      },
    };
  }, [currentSite, currentUser]);
};
